export default "__VITE_ASSET__DFL2gquv__"